module.exports = __webpack_public_path__ + "resources/img/banner-5.5555e72a.png";